module.exports = function() {


    window.REMODAL_GLOBALS = {

        NAMESPACE: 'modal',

        DEFAULTS: {

            hashTracking: false

        }

    };


    var inst = jQuery('[data-remodal-id=predictiveSearchModal]').remodal();

    jQuery('#search').on("click", function () {

        inst.open();

    });

    (function ($, window, document, undefined) {

        var elSelector = 'header',

            elClassHidden = 'header-white',

            throttleTimeout = 500,

            $element = jQuery(elSelector);

        if (!$element.length) return true;

        var $window = $(window),

            wHeight = 0,

            wScrollCurrent = 0,

            wScrollBefore = 0,

            wScrollDiff = 0,

            $document = $(document),

            dHeight = 0;

        if (document.getElementsByClassName('hero-cycle-wrapper')[0]) {

            $window.on('scroll', ICF.Utils.Throttle(throttleTimeout, function () {

                dHeight = $document.height();

                wHeight = $window.height();

                wScrollCurrent = $window.scrollTop();

                wScrollDiff = wScrollBefore - wScrollCurrent;

                if (wScrollCurrent <= 300) { // scrolled to the very top; element sticks to the top

                    $element.removeClass(elClassHidden);

                } else if (wScrollDiff > 0 && $element.hasClass(elClassHidden)) { // scrolled up; element slides in


                } else if (wScrollDiff < 0) { // scrolled down

                    $element.addClass(elClassHidden);

                }

                wScrollBefore = wScrollCurrent;

            }));

        }
        // controlling the header-white class for the overlapping header on Perspective Detail, News Detail, and Event Detail pages
        if (document.getElementsByClassName('whitepaper')[0]) {
            $window.on('scroll', ICF.Utils.Throttle(throttleTimeout, function () {
                dHeight = $document.height();
                wHeight = $window.height();
                wScrollCurrent = $window.scrollTop();
                wScrollDiff = wScrollBefore - wScrollCurrent;

                if (wScrollCurrent <= 100) { // scrolled to the very top; element sticks to the top
                    $element.removeClass(elClassHidden);
                } else if (wScrollDiff > 0 && $element.hasClass(elClassHidden)) { // scrolled up; element slides in
                } else if (wScrollDiff < 0) { // scrolled down
                    $element.addClass(elClassHidden);
                }
                wScrollBefore = wScrollCurrent;
            }));
        }

    })(jQuery, window, document);

    /*
     * 	Global Mobile Events
     */

    jQuery('#main-nav-collapse.accordion .accordion-body').on('show.bs.collapse', function (e) {

        e.stopPropagation();

        jQuery(e.target).closest('.accordion-group').addClass('active');

    });

    jQuery('#main-nav-collapse.accordion .accordion-body').on('hidden.bs.collapse', function (e) {

        e.stopPropagation();

        jQuery(e.target).closest('.accordion-group').removeClass('active');

    });

    jQuery('.navbar-toggle').on('click', function (e) {

        if (jQuery('.navbar-header').hasClass('expanded')) {

            jQuery('.navbar-header').removeClass('expanded');

        } else {

            jQuery('.navbar-header').addClass('expanded');

        }

    });
};